import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

function PolicyHolderInsureePicker({ defaultValue, newValues, error }) {
  const policyHolderInsurees = useSelector(
    (state) => state.profileReducer?.policyHolderInsurees
  );
  const { t } = useTranslation();

  return (
    <div>
      <Typography color="#666666" sx={{ mb: 0.6 }}>
        {t("adminManagement.form.policyHolderInsureeLabel")} *
      </Typography>

      {policyHolderInsurees && (
        <Autocomplete
          size="small"
          multiple={false}
          id="policyHolderInsuree-pickers"
          options={policyHolderInsurees.map((v) => v.insuree)}
          getOptionLabel={(option) =>
            `${option?.lastName} ${option?.otherNames}`
          }
          defaultValue={defaultValue}
          onChange={(event, newValue) => {
            newValues(newValue);
          }}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={t(
                "adminManagement.form.policyHolderInsureePlaceholder"
              )}
            />
          )}
        />
      )}

      {error && (
        <Typography variant="caption" color="red">
          {error}
        </Typography>
      )}
    </div>
  );
}

export default PolicyHolderInsureePicker;
